import { render, staticRenderFns } from "./Dipendenti.vue?vue&type=template&id=6ca5fdae"
import script from "./Dipendenti.vue?vue&type=script&lang=js"
export * from "./Dipendenti.vue?vue&type=script&lang=js"
import style0 from "./Dipendenti.vue?vue&type=style&index=0&id=6ca5fdae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports